var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCatalogueConfig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7344 49H5.25C2.35498 49 0 46.645 0 43.75V32.2656C0 29.3706 2.35498 27.0156 5.25 27.0156H16.7344C19.6294 27.0156 21.9844 29.3706 21.9844 32.2656V43.75C21.9844 46.645 19.6294 49 16.7344 49Z",
    fill: "#F66127"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.25 35.5H28.7656C27.7984 35.5 27.0156 34.7164 27.0156 33.75C27.0156 32.7836 27.7984 32 28.7656 32H47.25C48.2173 32 49 32.7836 49 33.75C49 34.7164 48.2173 35.5 47.25 35.5Z",
    fill: "#2D6289"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7656 39.5H38.0078C38.9751 39.5 39.7578 40.2836 39.7578 41.25C39.7578 42.2164 38.9751 43 38.0078 43H28.7656C27.7984 43 27.0156 42.2164 27.0156 41.25C27.0156 40.2836 27.7984 39.5 28.7656 39.5Z",
    fill: "#2D6289"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7344 22H5.25C2.35498 22 0 19.645 0 16.75V5.26562C0 2.37061 2.35498 0.015625 5.25 0.015625H16.7344C19.6294 0.015625 21.9844 2.37061 21.9844 5.26562V16.75C21.9844 19.645 19.6294 22 16.7344 22Z",
    fill: "#F66127"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.25 8.5H28.7656C27.7984 8.5 27.0156 7.71643 27.0156 6.75C27.0156 5.78357 27.7984 5 28.7656 5H47.25C48.2173 5 49 5.78357 49 6.75C49 7.71643 48.2173 8.5 47.25 8.5Z",
    fill: "#2D6289"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7656 12.5H38.0078C38.9751 12.5 39.7578 13.2836 39.7578 14.25C39.7578 15.2164 38.9751 16 38.0078 16H28.7656C27.7984 16 27.0156 15.2164 27.0156 14.25C27.0156 13.2836 27.7984 12.5 28.7656 12.5Z",
    fill: "#2D6289"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogueConfig);
export default __webpack_public_path__ + "static/media/catalogueConfig.7a6064d78e594dc8b767bba6611c5931.svg";
export { ForwardRef as ReactComponent };